var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenUpvote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66473 0.532171C6.37184 0.239278 5.89696 0.239278 5.60407 0.532171L0.831099 5.30514C0.538205 5.59803 0.538205 6.07291 0.831099 6.3658C1.12399 6.6587 1.59887 6.6587 1.89176 6.3658L6.1344 2.12316L10.377 6.3658C10.6699 6.6587 11.1448 6.6587 11.4377 6.3658C11.7306 6.07291 11.7306 5.59803 11.4377 5.30514L6.66473 0.532171ZM6.8844 16.0625L6.8844 1.0625H5.3844L5.3844 16.0625H6.8844Z",
    fill: "#1DCF5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUpvote);
export default __webpack_public_path__ + "static/media/greenUpvote.8299dddf945f808ce4fa585e94f3e01a.svg";
export { ForwardRef as ReactComponent };